import { Link } from 'react-router-dom';
import * as Icons from 'lucide-react';

export default function TemplateCard({ template }) {
  const Icon = Icons[template.icon] || Icons.FileText;
  return (
    <Link
      to={`/editor/${template.id}`}
      data-testid={`template-card-${template.id}`}
      className="group relative bg-white border border-stone-200/80 rounded-2xl p-5 hover:-translate-y-0.5 hover:shadow-sm transition-all overflow-hidden"
    >
      <div className="flex items-start justify-between mb-6">
        <div className="w-11 h-11 rounded-xl bg-stone-100 grid place-items-center text-stone-700 group-hover:bg-orange-600 group-hover:text-white transition-colors">
          <Icon size={20} strokeWidth={1.75} />
        </div>
        {template.popular && (
          <span className="text-[10px] uppercase tracking-wider font-medium bg-orange-100 text-orange-800 px-2 py-1 rounded-full">Popular</span>
        )}
      </div>
      <h3 className="font-display font-bold text-lg leading-tight tracking-tight">{template.title}</h3>
      <p className="text-sm text-stone-500 mt-2 leading-relaxed line-clamp-2">{template.description}</p>
      <div className="mt-5 flex items-center justify-between text-xs text-stone-500">
        <span className="uppercase tracking-wider">{template.category}</span>
        <span className="flex items-center gap-1 text-stone-900 font-medium group-hover:text-orange-600 transition-colors">
          Open <Icons.ArrowUpRight size={14} />
        </span>
      </div>
    </Link>
  );
}
